<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="450px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Transaction Fee</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :key="key"
          :fields="feeable"
          :method="method"
          :action="url"
          @submitted="$emit('submitted', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="min" type="number" label="Min Amount (Euros)" />
              </v-col>
              <v-col cols="12">
                <custom-input name="max" type="number" label="Max Amount (Euros)" />
              </v-col>
              <v-col cols="12">
                <custom-input name="value" type="number" label="Value (€)" />
              </v-col>
              <v-col cols="12" v-if="hasSendingCountry">
                <custom-select
                  name="sending_country_id"
                  :items="countries"
                  @changed="updateReceivingCountries"
                  item-text="name"
                  item-value="id"
                  label="Sending Country"
                />
              </v-col>
              <v-col cols="12" v-if="hasReceivingCountry">
                <custom-select
                  name="receiving_country_id"
                  :items="receivingCountries"
                  item-text="receiving_country.name"
                  item-value="receiving_country.id"
                  label="Receiving Country"
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Countries from "../transactionCountries/loadCountries";

export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    hasSendingCountry: { default: false, type: Boolean },
    hasReceivingCountry: { default: false, type: Boolean },
    feeable: {
      default: () => {},
      type: Object,
    },
    url: { required: true, type: String },
  },
  mixins: [Countries],
  data() {
    return {
      key: 1,
      receivingCountries: [],
    };
  },
  mounted() {
    this.loadCountries();
  },
  methods: {
    updateReceivingCountries(id) {
      this.$http.get(`/api/v1/transactions/transferCountries/${id}`).then((data) => {
        this.receivingCountries = data.receiving_countries;
      });
    },
  },
  watch: {
    isActive() {
      this.key += 1;
    },
  },
  computed: {},
};
</script>
